import React, { useContext, useState } from "react";
import LockIcon from "@mui/icons-material/Lock";
import { useQuery } from "@tanstack/react-query";
import CashierApi from "../../utility/CashierApi";
import GeneratePinModal from "./GeneratePinModal";
import { CustomerContext } from "../CashierHomepage";

function GeneratePin({ handleGeneratePasscode }) {
  const { fetchOnlyData } = CashierApi();

  const { openGeneratePassword, setOpenGeneratePassword } =
    useContext(CustomerContext);
  // const [open, setOpen] = useState(false);
  const handleClose = () => setOpenGeneratePassword(false);
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["cashierProfile"],
    queryFn: () => fetchOnlyData("users/profile"),
    enabled: false,
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  // console.log(data?.login_pin);
  const oldPin = data?.login_pin;

  const handlePinChange = () => {
    refetch();
    // setOpen(true);
    handleGeneratePasscode();
  };
  return (
    <>
      <LockIcon
        className="text-white cursor-pointer "
        onClick={() => handlePinChange()}
      />
      <GeneratePinModal
        oldPin={oldPin}
        open={openGeneratePassword}
        setOpen={setOpenGeneratePassword}
        handleClose={handleClose}
      />
    </>
  );
}

export default GeneratePin;
